module.exports = __webpack_public_path__ + "media/images/action-spacer-f87328a0cfe28ff6aa78b1398cd569bd.png";